import { Axios, AxiosError, AxiosResponse } from 'axios'
import { RemoteConfig } from './remote.config'

export class SupplierData {
	id: string
	name: string
	email: string
	phone: string
	hosts?: string[]

	constructor(id: string, name:string, email: string, phone: string) {
		this.id = id;
		this.name = name;
		this.email = email;
		this.phone = phone;
	}
}

export type SuppliersCallback = (data?: SupplierData[], resp?: AxiosResponse, err?: AxiosError) => void;

export const getSuppliers = (callback: SuppliersCallback) => {
	const client = new Axios();
	const url = new URL("/api/v0/supplier/", RemoteConfig.url);
	const result = client.get(url.toString(), {withCredentials:true}).then((resp) => {
		try {
			let data: SupplierData[] = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}

export const getOrganizationSuppliers = (orgId: string, callback: SuppliersCallback) => {
	const client = new Axios();
	const url = new URL(`/api/v0/organizations/${orgId}/suppliers`, RemoteConfig.url);
	const result = client.get(url.toString(), {withCredentials:true}).then((resp) => {
		try {
			let data: SupplierData[] = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}

export class CreateSupplierData {
	name: string
	email: string
	phone: string
	hosts?: string[]

	constructor(name: string, email: string, phone: string, hosts?: string[]) {
		this.name = name;
		this.email = email;
		this.phone = phone;
		this.hosts = hosts;
	}
}

export type CreateSupplierCallback = (data?: SupplierData, resp?: AxiosResponse, err?: AxiosError) => void;

export const createSupplier = (data: CreateSupplierData, callback: CreateSupplierCallback) => {
	const client = new Axios();
	const url = new URL("/api/v0/supplier/", RemoteConfig.url);
	const result = client.post(url.toString(), JSON.stringify(data), {withCredentials: true, headers: {
		'Content-Type': 'application/json'
	  }}).then((resp) => {
		try {
			let data: SupplierData = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}

export class UpdateSupplierData {
	name: string
	email: string
	phone: string
	hosts?: string[]

	constructor(name: string, email: string, phone: string, hosts?: string[]) {
		this.name = name;
		this.email = email;
		this.phone = phone;
		this.hosts = hosts;
	}
}

export type UpdateSupplierCallback = (data?: SupplierData, resp?: AxiosResponse, err?: AxiosError) => void;

export const updateSupplier = (supplierId: string, data: UpdateSupplierData, callback: UpdateSupplierCallback) => {
	const client = new Axios();
	const url = new URL(`/api/v0/supplier/${supplierId}`, RemoteConfig.url);
	const result = client.post(url.toString(), JSON.stringify(data), {withCredentials: true, headers: {
		'Content-Type': 'application/json'
	  }}).then((resp) => {
		try {
			let data: SupplierData = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}

export type GetSupplierCallback = (data?: SupplierData, resp?: AxiosResponse, err?: AxiosError) => void;

export const getSupplier = (id: string, callback: GetSupplierCallback) => {
	const client = new Axios();
	const url = new URL(`/api/v0/supplier/${id}`, RemoteConfig.url);
	const result = client.get(url.toString(), {withCredentials:true}).then((resp) => {
		try {
			let data: SupplierData = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}

export class AddSuppliersToOrganizationData {
	suppliers: string[]

	constructor(suppliers: string[]) {
		this.suppliers = suppliers;
	}
}

export type AddSuppliersToOrganizationCallback = (resp?: AxiosResponse, err?: AxiosError) => void;

export const addSupplierToOrganization = (orgId: string, data: AddSuppliersToOrganizationData, callback: AddSuppliersToOrganizationCallback) => {
	const client = new Axios();
	const url = new URL(`/api/v0/organizations/${orgId}/suppliers`, RemoteConfig.url);
	const result = client.post(url.toString(), JSON.stringify(data), {withCredentials: true, headers: {
		'Content-Type': 'application/json'
	  }}).then((resp) => {
		try {
			callback(resp)
		} catch {
			callback(resp)
		}
	})
}
